import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import PhotoSwipe from 'photoswipe/dist/umd/photoswipe.umd.min';
import ObjectPosition from '@vovayatsyuk/photoswipe-object-position/photoswipe-object-position.js';

export default class LightboxImage {
    static init() {
        if (document.body.classList.contains('neos-backend')) {
            return;
        }

        Array.prototype.forEach.call(document.querySelectorAll('.image-lightbox'), el => {
            new LightboxImage(el);
        });
    }

    constructor(element) {

        if (!element) return;

        this.elementNode = element;
        this.imgNode = this.elementNode.querySelector('img');

        // skip if it is part of gallery, gallery.js will take care of it.
        let isGallery = this.elementNode.parentNode.classList.contains('gallery__slide');
        if (isGallery) return;

        this.lightbox = new PhotoSwipeLightbox({
            gallery: this.elementNode,
            pswpModule: PhotoSwipe
        });

        new ObjectPosition(this.lightbox);

        this.lightbox.addFilter('domItemData', (itemData, element) => {
            itemData.src = element.dataset.pswpSrc;
            itemData.w = parseInt(element.dataset.pswpWidth);
            itemData.h = parseInt(element.dataset.pswpHeight);
            itemData.msrc = this.imgNode.src;
            itemData.thumbCropped = true;

            return itemData;
        });

        this.lightbox.init();
    }
}
